import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">DCCannaBliss · Elevate Your Understanding</p>
        <h1>Stay Informed on Cannabis Policy and Culture</h1>
        <p className="lede">
          At DCCannaBliss, we are committed to delivering the latest news and insights on cannabis laws, policies, and cultural developments in our area. Join us in exploring the evolving landscape of cannabis.
        </p>
        <div className="cta-row">
          <a href="/news" target="_self">
            Read the Latest News
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Cannabis Law Updates</h2>
          <p>
            Stay updated with the latest changes in cannabis legislation and how they impact our community.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Get clear information about the legal status of cannabis in our area, including regulations and compliance.
          </p>
        </article>
        <article>
          <h2>Educational Resources</h2>
          <p>
            Access a wealth of educational content designed to inform and empower you about cannabis culture and its implications.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;
